/**
 * PlatformARPlatformLaunchDemoView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait PlatformARPlatformLaunchDemo
 */

import { usePlatformARPlatformLaunchDemoLogic } from '@/hooks/traits/usePlatformARPlatformLaunchDemoLogic';
import type { PlatformARPlatformLaunchDemoConfig } from '@/hooks/traits/usePlatformARPlatformLaunchDemoLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { PlatformARDemoLaunchEntry } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { PlatformARDemoLaunchTourView } from '@/components/traits/PlatformARDemoLaunchTourView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface PlatformARPlatformLaunchDemoViewProps {
  config?: Partial<PlatformARPlatformLaunchDemoConfig>;
}

export function PlatformARPlatformLaunchDemoView({ config: propsConfig }: PlatformARPlatformLaunchDemoViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = usePlatformARPlatformLaunchDemoLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['PlatformARDemoLaunchEntry'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="PlatformAR" trait="PlatformARPlatformLaunchDemo">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="md"><PlatformARDemoLaunchTourView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default PlatformARPlatformLaunchDemoView;
